import React from 'react';

const Abbr = ({ short, long }) => <abbr title={long}>{short}</abbr>;

export default Abbr;
